import { ApplicationConfig, isDevMode  } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withJsonpSupport } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { RECAPTCHA_V3_SITE_KEY, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideClientHydration(withHttpTransferCacheOptions({
        includePostRequests: true,
    })),
    provideHttpClient(withFetch(), withJsonpSupport()),
    provideAnimationsAsync(),
    provideLottieOptions({
        player: () => import('lottie-web/build/player/lottie_light'),
    }),
    provideCacheableAnimationLoader(),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LdmfcopAAAAABQqOh9DtpaCeKuu8ZUdcuhDINzI' },
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }), 

]
};
